import {Injectable} from '@angular/core';
import {catchError, map, Observable, of} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {Day} from "../model/data.model";

@Injectable({
    providedIn: 'root'
})
export class JsonService {

    constructor(private http: HttpClient) {
    }

    getAllData(): Observable<Day[]> {
        return this.http.get<Day[]>('assets/data.json').pipe(
            map(data =>data),
            catchError(error => {
                console.error('Error fetching data:', error);
                return of([]);
            })
        );
    }

    getByDayNumber(dayNumber: number): Observable<Day | undefined> {
        return this.getAllData().pipe(
            map(data => data.find(day => day.dayNumber === dayNumber))
        );
    }

    getLatestDay(): Observable<Day> {
      return this.getAllData().pipe(
        map(data => data.reverse()[0])
      );
    }

}
